import { createSlice } from "@reduxjs/toolkit";
import {
  cancelSponsorship,
  getCancelReasons,
  getSponsorshipCancel,
} from "../actions/sponsorship.actions";

const initialState = {
  sponsorshipCancel: [] as any,
  cancelReasons: [] as any,
  sponsorship: {} as any,
  isLoading: false as boolean,
  loading: false as boolean,
  error: null as unknown | null,
  TotalCancels : 0 as number,
};
export const sponsorshipSlice = createSlice({
  name: "sponsorship",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* get SponsorShip Cancel */
    builder.addCase(getSponsorshipCancel.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSponsorshipCancel.fulfilled, (state, action) => {
      state.sponsorshipCancel = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getSponsorshipCancel.rejected, (state, action) => {
      state.sponsorshipCancel = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* get Cancel Reasons*/
    builder.addCase(getCancelReasons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCancelReasons.fulfilled, (state, action) => {
      state.cancelReasons = action.payload.data;
      state.loading = false;
    });
    builder.addCase(getCancelReasons.rejected, (state, action) => {
      state.cancelReasons = [];
      state.loading = false;
      state.error = action.payload;
    });
    /* Cancel sponsorship*/
    builder.addCase(cancelSponsorship.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(cancelSponsorship.fulfilled, (state, action) => {
      state.sponsorship = action.payload;
      state.isLoading = false;
    });
    builder.addCase(cancelSponsorship.rejected, (state, action) => {
      state.sponsorship = {};
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default sponsorshipSlice.reducer;
